import script from "./MessageCommentsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageCommentsCard.vue?vue&type=script&setup=true&lang=ts"

import "./MessageCommentsCard.vue?vue&type=style&index=0&id=75eb9961&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75eb9961"]])

export default __exports__